// extracted by mini-css-extract-plugin
module.exports = {"events":"events-module--events--bELKa","preference":"events-module--preference--2EiET","link":"events-module--link--13zr9","centerLink":"events-module--centerLink--2YGrN"};